<template>
  <v-dialog
    v-model="dialogVisible" 
    persistent
    max-width="360px" 
  >
    <template v-slot:activator="scope">
      <activator-button :scope="scope" />
    </template>

    <v-form @submit.prevent="submitClick">
      <v-card>
        <v-card-title>Edit your Profile</v-card-title>
        <v-divider />
        <v-card-text class="pb-0">
          <v-text-field
            outlined dense
            :disabled="true"
            v-model="email"
            label="Email"
          />
          <v-text-field
            outlined dense
            v-model="name"
            label="Name"
          />
          <v-text-field
            outlined dense
            v-model="display_name"
            label="Display Name"
          />
        </v-card-text>

        <v-divider />

        <v-card-actions class="justify-center">
          <v-btn @click="close">Cancel</v-btn>
          <v-btn color="primary" type="submit">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
  import { ActivatorButton } from '@/components/pages'
  import api from '@/lib/api'

  export default {
    name: 'UserContactDialog',

    props: ['user'],

    components: { ActivatorButton },

    data() {
      return {
        dialogVisible: false,

        name: '',
        display_name: '',
        email: '',
      }
    },

    watch: {
      dialogVisible(visible) {
        const { email, display_name, name } = this.user
        if( visible ) {
          this.email = email
          this.display_name = display_name
          this.name = name
        }
      },
    },

    methods: {
      close() {
        this.dialogVisible = false
      },

      async submitClick() {
        const { name, display_name } = this
        const payload = {
          user: { name, display_name }
        }

        let result = await api.put(`/users/${ this.user.user_id }`, payload)
        if( result.ok ) {          
          result.json().then(me => { this.$store.commit('auth/SET_ME', me) })
          this.close()
        }
      },
    
    },
  };
</script>

<style scoped>
  .v-dialog__content {
    position:  absolute;
  }
</style>